var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "file-card",
      on: {
        click: _vm.handleClick,
        mouseenter: _vm.handlerMouseenter,
        mouseleave: _vm.handlerMouseleave,
      },
    },
    [
      _vm.isNew && _vm.taskStatus === "DONE"
        ? _c("div", { staticClass: "new-icon" }, [_vm._v("new")])
        : _vm._e(),
      _vm.taskStatus === "PENDING"
        ? _c("svg-icon", {
            staticClass: "type-icon",
            attrs: { "icon-class": _vm.iconTypeWaitingMap[_vm.taskType] },
          })
        : _c("svg-icon", {
            staticClass: "type-icon",
            attrs: { "icon-class": _vm.iconTypeMap[_vm.taskType] },
          }),
      _c(
        "div",
        { staticClass: "file-info" },
        [
          _c(
            "el-tooltip",
            {
              attrs: {
                effect: "dark",
                content: _vm.title || _vm.taskName,
                placement: "top",
                disabled: _vm.isShowTooltip,
                "popper-class": "custom-zyq-prpper",
              },
            },
            [
              _c(
                "p",
                {
                  ref: "fileTitleRef",
                  staticClass: "file-title",
                  on: {
                    mouseenter: function ($event) {
                      return _vm.mouseEnterShowTooltip("fileTitleRef")
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.title || _vm.taskName) + " ")]
              ),
            ]
          ),
          _vm.isShowFileCardCenter
            ? _c("div", { staticClass: "file-info-center" }, [
                _c(
                  "div",
                  { staticClass: "file-status" },
                  [
                    _c("svg-icon", {
                      attrs: {
                        "icon-class": _vm.fileCardCenterClass.taskStatusIcon,
                      },
                    }),
                    _c(
                      "span",
                      {
                        staticClass: "file-status-text",
                        class: {
                          "error-text": _vm.taskStatus === "FAILED",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.fileCardCenterClass.taskStatusText) +
                            " "
                        ),
                      ]
                    ),
                    _vm.taskStatus === "WAITING"
                      ? _c("svg-icon", { attrs: { "icon-class": "_wating" } })
                      : _vm._e(),
                    _vm.taskStatus === "UPLOADING"
                      ? _c("svg-icon", { attrs: { "icon-class": "waiting" } })
                      : _vm._e(),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm.isShowFileCardBottom
            ? _c("div", { staticClass: "file-info-bottom" }, [
                _c(
                  "div",
                  { staticClass: "file-info-bottom-item" },
                  [
                    _vm.taskStatus === "DONE" || _vm.taskStatus === "FAILED"
                      ? [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content: _vm.fileCardBottomClass.leftText,
                                placement: "bottom",
                                disabled: _vm.isShowTooltip,
                                "popper-class": "custom-zyq-prpper",
                              },
                            },
                            [
                              _c(
                                "p",
                                {
                                  ref: "bottomTextRef",
                                  staticClass:
                                    "file-info-bottom-item-text left-text bottom-text",
                                  class: {
                                    "error-text": _vm.taskStatus === "FAILED",
                                  },
                                  on: {
                                    mouseenter: function ($event) {
                                      return _vm.mouseEnterShowTooltip(
                                        "bottomTextRef"
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.fileCardBottomClass.leftText) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticClass:
                                "file-info-bottom-item-text right-text",
                              class: {
                                "error-text-btn": _vm.taskStatus === "FAILED",
                              },
                              on: { click: _vm.handleRetry },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.fileCardBottomClass.rightText) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      : _vm._e(),
                    _vm.taskStatus === "PENDING"
                      ? [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "100%",
                                display: "flex",
                                "align-items": "center",
                                gap: "8px",
                              },
                            },
                            [
                              _c("svg-icon", {
                                attrs: {
                                  "icon-class":
                                    _vm.fileCardBottomClass.leftText,
                                },
                              }),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "file-info-bottom-item-text left-text",
                                  class: {
                                    "error-text": _vm.taskStatus === "FAILED",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.fileCardBottomClass.rightText
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                    _vm.taskStatus === "UPLOADING"
                      ? [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "100%",
                                display: "flex",
                                "align-items": "center",
                                gap: "8px",
                              },
                            },
                            [
                              _c("svg-icon", {
                                attrs: {
                                  "icon-class":
                                    _vm.fileCardBottomClass.leftText,
                                },
                              }),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "file-info-bottom-item-text left-text",
                                  class: {
                                    "error-text": _vm.taskStatus === "FAILED",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.fileCardBottomClass.rightText
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c("svg-icon", {
                                attrs: {
                                  "icon-class":
                                    _vm.fileCardBottomClass.rightIcon,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c("svg-icon", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isShowCloseIcon,
            expression: "isShowCloseIcon",
          },
        ],
        staticClass: "close-icon",
        attrs: { "icon-class": "_close" },
        on: { click: _vm.remove },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }